module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox, $) {
	'use strict';

	//var EXO_UDID = require('../../../../../common-components/verification-form/exo-udid')(fox);
	var EXO_UDID = require('../../../../../../../../common-components/verification-form/exo-udid')(fox);

	fox.registerWidget('Home_Registration', {
		configure: function(options) {
			this.registerOptions('', {
				autoRender: true,
				template: 'home_registration',
				container: '#signup-form-wrapper',
				widgets: {
					signupForm: {
						widget: 'Form',
						formContainer: '#signup-form',
						formElements: {
							userName: {
								element: '[name="userName"]',
								defaultValue: ''
							},
							firstName: {
								element: '[name="firstName"]',
								defaultValue: ''
							},
							lastName: {
								element: '[name="lastName"]',
								defaultValue: '',
							},
							affiliateUrl: {
								element: '[name="affiliateUrl"]',
								defaultValue: '',
								validate: [
									{
										validator: 'regexp',
										options: {regexp: fox.regexp.url},
										message: 'Wrong domain name format'
									}
								]
							},
							email: {
								element: '[name="email"]',
								defaultValue: '',
								autoApply: true,
								validate: [{validator: 'regexp', options: {type: 'emailCaseInsensitive'}, message: 'Wrong email format'}]
							},
							consent_tos: {
								element: '[name="consent_tos"]',
								defaultValue: false,
							},
							consent_marketing: {
								element: '[name="consent_marketing"]',
								defaultValue: false,
							}
						},
						methods: {
							send: 'affiliate.whitelabel.register',
							sendMethod: 'post',
							encodePost: true
						},
						submit: {
							target: '#signup-form',
							event: 'submit'
						},
						'widgets.validator': {
							widget: 'Easy_Form_Validator',
							formWidget: '@parent',
							hangClassLocation: 'parentNode',
							requiredFields: ['userName','firstName','lastName','email', 'consent_tos', 'affiliateUrl'],
							defaultValidator: [{
								validator: 'length',
								options: {min: 1},
								message: 'Please fill in required fields'
							}]
						},
						hooks: {
							onResponse: '@parent:formIsSubmitted',
							onSubmit: '@parent:formSubmit',
							// onStopPrepareValues: function(form) {
							// 	form._preparedValues.udid = this._udid;
							// 	console.log('onPreparevalues', form._preparedValues);
							// }.bind(this)
						},
						handleWom: {
							formError: {
								event: 'formNotValid',
								widget: '@this #validator',
								callback: '@parent:formNotValid'
							}
						}
					}
				},
				handleDom: {
					focus: {
						target: 'input[name]',
						event: 'focus',
						callback: '_handleFocus'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function (argument) {
			this.form = this.rwom1('#signupForm');
			this.notices = fox.wom.selectFirst('~#throughNotifications');
			this.callParent('running', arguments);
		},

		_handleFocus: function (el) {
			$(el).parent().removeClass('error').find('.error-container').text('');
		},

		formIsSubmitted: function (response) {
			var button = fox.dom.selectFirst('.button-with-spinner', this.element);
			this.form.ignoreSubmit(false);

			if (response.type === 'error' && response.answer.answer !== '50102') {
				if (Number(response.answer.answer.code) === 50102) {
					this.wom1('@parent #warningPopup').show();
				} else {
					this.notices.pushNotification({
						noticeTemplate: 'new_notice',
						noticeType: 'error',
						noticeMessage: response.answer.answer.reason,
						noticeAlias: 'signupError',
						delayClose: 3000
					});
				}
				fox.dom.removeClass('spin', button);
				return;
			}
			window.location.reload();
		},

		formSubmit: function () {
			this.getUDID().then(function(_udid) {
				var button = fox.dom.selectFirst('.button-with-spinner', this.element);
				this.form._preparedValues.udid = _udid;

				this.form.submit();
				this.form.ignoreSubmit(true);
				
				fox.dom.addClass('spin', button);
			}.bind(this));
		},

		formNotValid: function (errorsObj) {
			fox.each(errorsObj.errorStack, function (arr, name) {
				var err = arr[0];

				$(this.dom1('[name="' + name + '"]'))
					.parent()
					.find('.error-container')
					.text(err.message);
			}, this);
		},

		getUDID: function() {
            return EXO_UDID.getShortUid();
		},

	}, 'Widget');
})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/home/home/registration.js
// module id = 194
// module chunks = 5